export const portfolioData = [
  {
    id: 'family-media',
    title: 'Family Media App',
    description: 'A comprehensive media platform that allows users to watch Family TV, listen to Family Radio and Radio 316 live on their mobile devices.',
    fullDescription: 'Family Media App is a revolutionary mobile application that brings live television and radio streaming to your fingertips. Developed as a cross-platform solution, it allows users to access Family TV, Family Radio, and Radio 316 from anywhere with an internet connection.',
    features: [
      'Live TV streaming with high-quality video',
      'Multiple radio station support',
      'User-friendly interface optimized for mobile',
      'Cross-platform compatibility (iOS & Android)'
    ],
    techStack: ['Flutter', 'iOS', 'Android', 'Live Streaming', 'Firebase'],
    imageColor: '#165f7eff',
    icon: 'fas fa-tv',
    image: '/images/projects/familytv.png',
    detailImage: '/images/projects/familymedia.jpg',
    galleryImages: [
      {
        url: '/images/projects/familymediaappst.png',
        caption: '',
        description: ''
      },
      {
        url: '/images/projects/familytv.png',
        caption: '',
        description: ''
      }
    ],
    appLinks: [
      {
        platform: 'Android',
        url: 'https://play.google.com/store/apps/details?id=com.familymedia.tv',
        icon: 'fab fa-android'
      },
      {
        platform: 'iOS',
        url: 'https://apps.apple.com/us/app/family-media/id1488345441',
        icon: 'fab fa-apple'
      }
    ],
    results: 'Launched with 5,000+ downloads, maintaining 4.5+ star rating on both app stores'
  },
  {
    id: 'milk-collection-app-for-dairy-management',
    title: 'Milk Collection App',
    description: 'Revolutionary dairy management system that uses Bluetooth technology to streamline milk collection and payment processes, with comprehensive online/offline functionality and a powerful web dashboard.',
    fullDescription: 'Milk Collection App transforms the dairy industry by digitizing the entire milk collection and distribution process. The mobile app works seamlessly both online and offline, ensuring uninterrupted operations even in remote areas with poor network connectivity. A powerful web dashboard complements the mobile app, providing centralized management and real-time insights across the entire dairy value chain.',
    features: [
      'Bluetooth scale integration for automatic weight recording - no manual entry required',
      'Bluetooth printer integration for instant digital receipt printing',
      'Android POS system compatibility with embedded printer support',
      'Farmer daily milk sales tracking with cumulative monthly totals',
      'Farmer database management with transaction history',
      'Payment tracking and history with M-Pesa integration',
      'Offline-first functionality with seamless sync when online',
      'Real-time data synchronization between mobile app and web dashboard',
      'Comprehensive web dashboard for centralized dairy management',
      'Automated payment calculation and payroll generation',
    ],
    featureNarrative: 'The mobile app revolutionizes milk collection by integrating directly with Bluetooth-enabled digital scales, eliminating manual weight recording and the errors that come with it. When a farmer delivers milk, the scale automatically transmits the weight to the app, which instantly generates and prints a receipt via a Bluetooth printer. For collection centers using Android POS systems, the app works seamlessly with embedded printers as well, ensuring flexibility across different setups.\n\n' +
      'Farmers benefit from complete transparency into their milk sales. The printed receipt allows them to view their daily milk sales immediately after each delivery/collection and track their cumulative sales for the month, giving them real-time insight into their income and helping them plan their finances better.\n\n' +
      'Beyond the core mobile capabilities, the system includes a comprehensive web dashboard that transforms how dairy businesses manage their operations. The dashboard provides real-time visibility into total milk collected across all collection points, with automated payment calculation and payroll generation that eliminates manual accounting errors. It allows farmers to receive advance payments against their future milk deliveries—a crucial feature that helps farmers manage cash flow during challenging seasons.\n\n' +
      'The platform manages the complete sales ecosystem, from bulk milk sales to dairy processors, to retail operations at company-owned factory gate shops (commonly known as plant shops or company retail outlets). Village-level summaries give managers granular insights into collection patterns, while the farmer customer management module tracks farmers who purchase dairy products from the company, creating a complete circle of engagement.\n\n' +
      'Financial transactions are streamlined through M-Pesa integration, enabling seamless digital payments to farmers and receipts from buyers. A critical quality control feature tracks milk spillage by reconciling quantity-in versus quantity-out, helping identify inefficiencies and reduce losses. This end-to-end approach creates a fully integrated dairy management solution that serves everyone from rural farmers to urban processors.',
    techStack: ['Android', 'Bluetooth Scale Integration', 'Bluetooth Printer', 'POS System Integration', 'SQLite', 'Web Dashboard', 'M-Pesa Daraja API', 'Real-time Sync', 'Online and Offline capabilities'],
    imageColor: '#0D3F69',
    icon: 'fas fa-weight',
    image: '/images/projects/milkstarsscreens.png',
    detailImage: '/images/projects/milkstarsscreens.png',
    galleryImages: [
      {
        url: '/images/projects/milkstars.jpg',
        caption: 'App Screenshot from either a mobile phone or the POS system',
        description: ''
      },
      {
        url: '/images/projects/milkstarsprint.jpeg',
        caption: 'Printing From the Android POS System',
        description: ''
      },
      {
        url: '/images/projects/milkstarsscreens.png',
        caption: '',
        description: ''
      },
      {
        url: '/images/projects/milkstarsscale.png',
        caption: 'Bluetooth Enabled Digital Scale',
        description: 'Eliminates manual weight recording errors by automatically transmitting weight data to the app via Bluetooth'
      },
      {
        url: '/images/projects/milkstarspos.png',
        caption: '',
        description: ''
      },
      {
        url: '/images/projects/milkstars_printer.png',
        caption: 'Mobile Printer Used for Receipts',
        description: 'Used with Bluetooth integration to print receipts directly from the mobile app if you are not using the android POS system with an embedded printer',
      }
    ],
    // webDashboard: {
    //   url: '',
    //   description: 'Access the web dashboard for centralized dairy management'
    // },
    results: 'Eliminated manual milk recording errors completely, reduced processing time by 70%, improved farmer satisfaction through real-time visibility of daily and monthly earnings, and streamlined end-to-end dairy operations from collection to retail sales.'
  },
];